import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { AutoComplete, Dropdown, Input, Skeleton, Tag } from "antd";
import Loading from "../../../Components/Loading/Loading";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import CustomModal from "../../../Components/Customs/CustomModal";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import { GoPlusCircle } from "react-icons/go";
import YukXatiShablon from "../../../Components/YukXati/YukXatiShablon";
import moment from "moment";
import Drivers from "./Drivers";
import { IoIosAdd } from "react-icons/io";
import formatNumberWithSpaces from "../../../Components/NumberToWords/FormatNumber";
import { StoreProfileInfo } from "../../../Stores/ProfileInfo/StoreProfileInfo";

const searchResult = (query) => {
  console.log(query);
  return query.map((el, idx) => {
    return {
      value: `${el.id}.  N:${el.auto_number}:  Shaf:${el.driver_name}:  PNFL:${el.PNFL}:`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>N:{el.auto_number}</span>
          <span>Shaf:{el.driver_name}</span>
          <span>PNFL:{el.PNFL}</span>
        </div>
      ),
    };
  });
};

const CustomerSearchResult = (query) => {
  return query.map((el, idx) => {
    return {
      value: `${el.id}. ${el.name}  INN:${el.INN}  TEL:${el.phone}`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{el.name}</span>
          <span>inn:{el.INN}</span>
          <span>{el.phone}</span>
        </div>
      ),
    };
  });
};

export default function YukXatiEdit() {
  let { data: productsNames } = StoreProfileInfo();
  const [loading, setLoading] = React.useState(false);
  let [data, setData] = useState({
    driver_name: null,
    auto_number: null,
    PNFL: null,
  });
  let [user, setUser] = useState(null);
  let [selected, setSelected] = useState(null);
  let [openModal, setOpenModal] = useState(false);
  let [names, setNames] = useState(false);
  const messageApi = useMessage();
  let { id } = useParams();

  let navigate = useNavigate();
  const location = useLocation();
  let [products, setProducts] = useState([
    {
      tonna: "",
      from_: "",
      name: "",
      price_qop: "",
    },
  ]);

  const handleUpload = (values) => {
    setData({
      ...data,
      ticket: values.ticket,
      ticket_date: values.ticket_date,
      comment: values.comment,
      date: values.date,
      status: values.status,
      where: values.where,
      products: [
        ...products.map((el) => {
          return {
            ...el,
          };
        }),
      ],
    });

    setOpenModal(true);
  };

  const getNames = async () => {
    try {
      setLoading(true);
      console.log(location);
      let user = await axiosInstance.get(
        "/api/chiqim/" + location?.search.split("?").join("")
      );

      setNames([...productsNames?.products]);
      setUser(user.data.data[0]);
      setData(user.data.data[0]);
      setProducts(user.data.data[0].products);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log(location.pathname.split("/")[1]);
    if (location?.search.length > 0) {
      getNames();
    }
  }, [location?.search]);

  const [options, setOptions] = useState([]);

  let searchDriver = async (val) => {
    try {
      let { data: driver } = await axiosInstance.get(
        "/api/drivers/search?search=" + val
      );

      if (driver.success) {
        console.log(driver);
        setOptions(val ? searchResult(driver?.data) : []);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    }
  };

  const handleAdd = async () => {
    try {
      // setLoading(true);
      let res = await axiosInstance.put(
        "/api/chiqim/" + location?.search?.split("?").join(""),
        {
          ...data,
          given_by:
            typeof data.given_by == "object"
              ? data.given_by.id
              : data?.given_by,
        }
      );
      console.log(res.data);

      if (res.data.success) {
        messageApi.open({
          type: "success",
          content: "Yukxati O'zgartirildi :)",
        });

        setOpenModal(false);
        if (
          data?.customer_id == id &&
          location.pathname.split("/")[1] == "yukxati"
        ) {
          navigate(-1, { replace: true });
        }
        if (data?.customer_id == id) {
          navigate(0, { replace: true });
        } else {
          navigate("/customers/" + data?.customer_id, { replace: true });
        }
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  const [customerOptions, setCustomerOptions] = useState([]);
  let [isModalOpen, setIsModalOpen] = useState(false);
  const [to_driver, setTo_driver] = useState(
    `1. N:${data?.auto_number}:  Shaf:${data?.driver_name}: PNFL:${data?.PNFL}:`
  );
  const [given_by, setGiven_by] = useState(
    `${data?.given_by?.id}. ${data?.given_by?.name}  INN:${data?.given_by?.INN}  TEL:${data?.given_by?.phone}`
  );
  let [customerId, setCustomerId] = useState(null);

  useEffect(() => {
    if (data?.auto_number) {
      setTo_driver(
        `1. N:${data?.auto_number}:  Shaf:${data?.driver_name}: PNFL:${data?.PNFL}:`
      );
    }
    if (data.given_by?.id) {
      setGiven_by(
        `${data?.given_by?.id}. ${data?.given_by?.name}  INN:${data?.given_by?.INN}  TEL:${data?.given_by?.phone}`
      );
    }
  }, [data]);

  const handleSearch = async (value) => {
    try {
      let { data } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      console.log(data);
      setSelected(data?.data);
      setCustomerOptions(value ? CustomerSearchResult(data?.data) : []);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    }
  };

  const onSelect_auto = (value) => {
    setSelected(value);

    let infos = value.split(":").filter((el, i) => {
      if (i !== 0 && i % 2 !== 0) {
        return el;
      }
    });
    console.log(
      value.split(":").filter((el, i) => {
        if (i !== 0 && i % 2 !== 0) {
          return el;
        }
      })
    );
    console.log(value);
    setData({
      ...data,
      driver_name: infos[1],
      auto_number: infos[0],
      PNFL: infos[2],
    });
  };

  const onSelect_person = (value) => {
    console.log(value.split(".")[0]);
    console.log(value);

    setData({
      ...data,
      given_by: Number(value.split(".")[0]),
    });
  };

  const onSelect_customer = (value) => {
    console.log(value.split(".")[0]);
    console.log(value);

    setData({
      ...data,
      customer_id: Number(value.split(".")[0]),
    });
  };

  let getUser = async () => {
    try {
      let { data: info } = await axiosInstance.get("/api/customers/" + id);

      console.log("data new");
      console.log(info);
      setCustomerId(
        `${info?.data?.id}. ${info?.data?.name}  INN:${info?.data?.INN}  TEL:${info?.data?.phone}`
      );
      setData({
        ...data,
        customer_id: id,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUser();
  }, []);

  if (loading) {
    return (
      <div>
        <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
          <Skeleton.Input
            active
            size="small"
            className=" text-[14px] text-[#111827] p-0 m-0 col-span-2 w-[30px] "
          />
        </div>
        <div
          className="flex flex-col gap-6 max-w-[900px] w-[90%] m-auto"
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {" "}
          <br></br>
          <Skeleton active />
          <br></br>
          <Skeleton active />
          {/* <Skeleton active />{" "} */}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[900px] w-[98%] m-auto mb-[40px] pb-[100px]">
      {loading ? <Loading /> : <></>}
      <CustomModal setOpenModal={setOpenModal} openModal={openModal}>
        <div className="flex flex-row items-start justify-between max-w-[900px] w-[98%] m-auto my-0">
          <button
            className="p-1"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <ClearOutlinedIcon />
          </button>
          {/* <h1 className="text-2xl font-bold m-0 text-center">Tekshir</h1> */}
          <Button
            variant="solid"
            icon={<GoPlusCircle className="font-[30px]" />}
            onClick={handleAdd}
          >
            Saqlash
          </Button>
        </div>
        {openModal ? <YukXatiShablon data={data} user={user} /> : null}
      </CustomModal>
      {location?.pathname.split("/")[1] +
        "/" +
        location?.pathname.split("/")[2] ==
      "yukxati/edit" ? (
        <>
          <br /> <br />
        </>
      ) : (
        <></>
      )}
      <div className="max-w-[900px] w-[100%] font-sans">
        <h2 className="text-[16px] text-center" style={{ textAlign: "center" }}>
          ЙУЛ ВАРАКАСИ{" "}
          <Tag color="error" className="ml-1">
            {" "}
            {user?.status}{" "}
          </Tag>
        </h2>
      </div>

      <div>
        <label htmlFor="driver_name">Kimga</label>
        <AutoComplete
          popupMatchSelectWidth={"100px"}
          style={{
            width: "100%",
          }}
          className="max-w-[900px]"
          options={customerOptions}
          onSelect={onSelect_customer}
          onSearch={handleSearch}
          value={customerId}
          onChange={(val) => {
            setCustomerId(val);
          }}
          size="large"
        >
          <Input.Search
            // loading={loadingCustomer}
            size="large"
            placeholder="Qidirish..."
            enterButton
          />
        </AutoComplete>
        <div className="flex flex-col md:flex-row flex-wrap items-center justify-start gap-[10px] w-[100%]">
          {products.map((el, index) => {
            return (
              <div className="relative bg-[#fff] p-4 shadow my-2 rounded w-[100%]  md:w-[49%]">
                <Tooltip title="Remove this">
                  <span
                    onClick={() => {
                      setProducts([
                        ...products.filter((prod, indx) => {
                          console.log(indx !== index);
                          if (indx != index) return prod;
                          console.log(index);
                          console.log(indx);
                        }),
                      ]);
                    }}
                    className="absolute top-1 right-0 flex flex-row align-center justify-center"
                  >
                    <IconButton color="delete">
                      <HighlightOffIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <div class="w-[100%]">
                  <label
                    for="options"
                    class="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Dori tanlang
                  </label>
                  <div class="relative">
                    <select
                      id="options"
                      onChange={(e) => {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                name: e.target.value,
                              };
                            }
                            return itm;
                          }),
                        ]);
                      }}
                      value={products[index].name}
                      class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Dori turi</option>
                      {names
                        ? names?.map((el) => {
                            return <option value={el.name}>{el.name}</option>;
                          })
                        : null}
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M7 10l5 5 5-5H7z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-[100%] gap-1 justify-between">
                  <div class=" w-[100%] md:w-[50%]">
                    <label
                      for="input-with-helper-text"
                      class="block text-sm font-medium text-gray-700"
                    >
                      {products[index].tonna} Tonna (
                      {(products[index].tonna * 1000) / 50} - qop)
                    </label>
                    <input
                      value={products[index].tonna}
                      type="number"
                      onChange={(e) => {
                        if (e.target.value === "") {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  tonna: e.target.value,
                                };
                              }
                              return itm;
                            }),
                          ]);

                          return;
                        }

                        if (!isNaN(e.target.value)) {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  tonna: Number(e.target.value),
                                };
                              }
                              return itm;
                            }),
                          ]);

                          return;
                        }
                      }}
                      id="input-with-helper-text"
                      class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Tonnasi"
                    />
                  </div>

                  <div class="w-[100%] md:w-[50%]">
                    <label
                      for="options"
                      class="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Qayerdan
                    </label>
                    <div class="relative">
                      <select
                        id="options"
                        value={products[index].from_}
                        onChange={(e) => {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  from_: e.target.value,
                                };
                              }

                              return itm;
                            }),
                          ]);
                        }}
                        class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="">Qayerdan</option>
                        <option value="Paxta zavod">Paxta zavod</option>
                        <option value="Ko'mirxona">Ko'mirxona</option>
                        <option value="Vagon">Molxona</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M7 10l5 5 5-5H7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" w-[100%] md:w-[100%]">
                  <label
                    for="input-with-helper-text"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Qop Narxi:{" "}
                    {formatNumberWithSpaces(
                      products[index]?.price_qop
                        ? products[index]?.price_qop
                        : ""
                    )}
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                price_qop: e.target.value,
                              };
                            }
                            return itm;
                          }),
                        ]);

                        return;
                      }

                      if (!isNaN(e.target.value)) {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                price_qop: Number(e.target.value),
                              };
                            }
                            return itm;
                          }),
                        ]);

                        return;
                      }
                    }}
                    value={products[index].price_qop}
                    id="input-with-helper-text"
                    class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Qop Narxi"
                  />
                </div>
              </div>
            );
          })}

          <br />
        </div>
        {/* controllers */}
        <div className="w-[100%] gap-[100px] flex flex-row align-center justify-end">
          <Box className="flex flex-row  align-center justify-between">
            <Tooltip title="Add New Question">
              <span
                onClick={() => {
                  setProducts([
                    ...products,
                    {
                      tonna: "",
                      from_: "",
                      name: "",
                      price_qop: "",
                    },
                  ]);
                }}
                className="flex flex-row align-center justify-center"
              >
                <IconButton color="primary">
                  <ControlPointIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </div>
        {/* main form */}
        <div className="relative my-4">
          <label htmlFor="driver_name">Auto raqam</label>{" "}
          <Drivers setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
          <div className="flex flex-row gap-1">
            <AutoComplete
              popupMatchSelectWidth={"100px"}
              style={{
                width: "100%",
              }}
              className="max-w-[900px]"
              options={options}
              onSelect={onSelect_auto}
              onSearch={searchDriver}
              value={to_driver}
              onChange={(val) => {
                setTo_driver(val);
              }}
              size="large"
            >
              <Input.Search
                // loading={loadingCustomer}
                size="large"
                placeholder="Qidirish..."
                enterButton
              />
            </AutoComplete>
            <Button
              variant="outlined"
              className="w-[50px] "
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <IoIosAdd />
            </Button>
          </div>
        </div>
        <label htmlFor="driver_name">Shafyor ismi</label>
        <Input
          loading={loading}
          size="large"
          placeholder="Auto raqam..."
          enterButton
          value={data.driver_name}
          disabled={true}
          onChange={(e) => {
            setData({
              ...data,
              driver_name: e.target.value,
            });
            // console.log(e.target.value);
          }}
        />
        <br />
        <br />
        <label htmlFor="driver_name">Shafyor pinfilli</label>
        <Input
          loading={loading}
          size="large"
          placeholder="Auto raqam..."
          disabled={true}
          enterButton
          value={data.PNFL}
          onChange={(e) => {
            setData({
              ...data,
              PNFL: e.target.value,
            });
            // console.log(e.target.value);
          }}
        />
        <br />
        <label htmlFor="driver_name">Beribyuborgan shaxs</label>
        <AutoComplete
          popupMatchSelectWidth={"100px"}
          style={{
            width: "100%",
          }}
          className="max-w-[900px]"
          options={customerOptions}
          value={given_by}
          onChange={(val) => {
            setGiven_by(val);
          }}
          onSelect={onSelect_person}
          onSearch={handleSearch}
          size="large"
        >
          <Input.Search
            // loading={loadingCustomer}
            size="large"
            placeholder="Qidirish..."
            enterButton
          />
        </AutoComplete>
        {/* main form */}
        <Formik
          initialValues={{
            status: data.status,
            date: moment(data.date).format("YYYY-MM-DD"),
            where: data.where,
            comment: data.comment,
          }}
          enableReinitialize={true}
          validationSchema={Yup.object({
            date: Yup.string().required("Yozish shart"),
            where: Yup.string(),
            status: Yup.string().required("tanlanishi shart"),
          })}
          onSubmit={(values) => {
            if (
              products.every(
                (obj) =>
                  obj?.tonna &&
                  obj?.from_?.trim()?.length &&
                  obj?.name?.trim()?.length
              )
            ) {
              handleUpload(values);
            }
          }}
        >
          <Form>
            <br />

            {/*where */}
            <label htmlFor="where">Qayerga</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="where"
              type="text"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="where" />
            </div>
            <br />
            {/* date */}
            <label htmlFor="date">Sana</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="date"
              type="date"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="date" />
            </div>
            <br />

            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="summa_bergan" />
            </div>
            <br />

            <label htmlFor="status">status</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="status"
              as="select"
            >
              <option value="">Статуст танланг</option>
              <option value="Насия">Насия</option>
              <option value="Накт">Накт</option>
              <option value="Биржа">Биржа</option>
              <option value="Перечесление">Перечесление</option>
              <option value="Шахобча">Шахобча</option>
            </Field>
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="status" />
            </div>
            <br />

            {/* comment */}
            <label htmlFor="comment">Izox</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="comment"
              as="textarea"
              rows="4"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="comment" />
            </div>
            <br />
            <br />
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
            >
              O'zgartirish
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
}
